<template>
  <v-dialog
    :value="value"
    max-width="640"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="text-subtitle-1">
        顧客を追加
        <v-spacer />
        <v-btn
          icon
          @click="close"
        >
          <v-icon>{{ icons.mdiClose }}</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-3">
        <v-text-field
          v-model="searchQuery"
          placeholder="名前 or 会員番号で検索"
          :prepend-inner-icon="icons.mdiMagnify"
          outlined
          dense
          hide-details
          class="mb-3"
          @input="onSearch"
        />

        <v-list
          v-if="customers.length > 0"
          dense
        >
          <v-list-item
            v-for="customer in customers"
            :key="customer.id"
            :disabled="isAlreadySelected(customer.id)"
            @click="selectCustomer(customer)"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ customer.attributes.name }}
                <span
                  v-if="customer.attributes.memberNumber"
                  class="text--secondary text-caption"
                >(#{{ customer.attributes.memberNumber }})</span>
              </v-list-item-title>
              <v-list-item-subtitle v-if="customer.attributes.memo">
                {{ customer.attributes.memo }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="isAlreadySelected(customer.id)">
              <v-icon
                small
                color="grey"
              >
                {{ icons.mdiCheck }}
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <div
          v-else-if="searchQuery && !isSearching"
          class="text-center text--secondary pa-4"
        >
          該当する顧客が見つかりません
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose, mdiMagnify, mdiCheck } from '@mdi/js'
import CustomerApi from '@/api/waiter/Customer'

export default {
  name: 'CustomerSelectDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      icons: { mdiClose, mdiMagnify, mdiCheck },
      searchQuery: '',
      customers: [],
      isSearching: false,
      searchTimeout: null,
    }
  },
  methods: {
    onSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.fetchCustomers()
      }, 300)
    },
    async fetchCustomers() {
      if (!this.searchQuery) {
        this.customers = []

        return
      }

      this.isSearching = true
      try {
        const { data } = await CustomerApi.getCustomers({ q: this.searchQuery, perPage: 20 })
        this.customers = data.data || []
      } catch {
        this.customers = []
      } finally {
        this.isSearching = false
      }
    },
    selectCustomer(customer) {
      if (this.isAlreadySelected(customer.id)) return
      this.$emit('select', {
        id: parseInt(customer.id, 10),
        name: customer.attributes.name,
        memberNumber: customer.attributes.memberNumber,
        birthday: customer.attributes.birthday,
        memo: customer.attributes.memo,
      })
    },
    isAlreadySelected(id) {
      return this.selectedIds.includes(parseInt(id, 10))
    },
    close() {
      this.searchQuery = ''
      this.customers = []
      this.$emit('input', false)
    },
  },
}
</script>

<style scoped>
/* タブレット向け: Vuetifyのtext-caption(12px)をこの画面では読みやすいサイズに上書き */
.text-caption {
  font-size: 13px !important;
  font-weight: 500 !important;
}
</style>
